import styled from "styled-components";
import {
  moving,
  rotate,
} from "../../constants/animationConstants";

export const UpDownElements = styled.img`
  @media (min-width: 768px) {
    position: absolute;
    margin-top: 20px;
    animation: ${moving} 3s linear infinite;
  }

  @media (min-width: 1440px) {
    margin-top: -570px;
    margin-left: 470px;
  }
`;

export const Star1 = styled.img`
  @media (min-width: 768px) {
    position: absolute;
    margin-top: 70px;
    margin-left: 320px;
    animation: ${rotate} 3s linear infinite;
  }

  @media (min-width: 1440px) {
    margin-top: -560px;
    margin-left: 800px;
  }
`;

export const Star2 = styled.img`
  @media (min-width: 768px) {
    position: absolute;
    margin-top: 310px;
    margin-left: 150px;
    animation: ${rotate} 3s linear infinite;
  }

  @media (min-width: 1440px) {
    margin-top: -330px;
    margin-left: 620px;
  }
`;

export const Star3 = styled.img`
  @media (min-width: 768px) {
    position: absolute;
    margin-top: 470px;
    margin-left: 360px;
    animation: ${rotate} 3s linear infinite;
  }

  @media (min-width: 1440px) {
    margin-top: -130px;
    margin-left: 860px;
  }
`;

export const Star4 = styled.img`
  @media (min-width: 768px) {
    position: absolute;
    margin-top: 520px;
    margin-left: 460px;
    animation: ${rotate} 3s linear infinite;
  }

  @media (min-width: 1440px) {
    margin-top: -130px;
    margin-left: 960px;
  }
`;

export const Star5 = styled.img`
  @media (min-width: 768px) {
    position: absolute;
    margin-top: 600px;
    margin-left: 400px;
    animation: ${rotate} 3s linear infinite;
  }

  @media (min-width: 1440px) {
    margin-top: 40px;
    margin-left: 960px;
  }
`;

export const Letter1 = styled.img`
  @media (min-width: 768px) {
    position: absolute;
    margin-top: 100px;
    margin-left: 270px;
  }

  @media (min-width: 1440px) {
    margin-top: -530px;
    margin-left: 740px;
  }
`;

export const Letter2 = styled.img`
  @media (min-width: 768px) {
    position: absolute;
    margin-top: 200px;
    margin-left: 210px;
  }

  @media (min-width: 1440px) {
    margin-top: -430px;
    margin-left: 680px;
  }
`;

export const Letter3 = styled.img`
  @media (min-width: 768px) {
    position: absolute;
    margin-top: 500px;
    margin-left: 600px;
  }

  @media (min-width: 1440px) {
    margin-top: -110px;
    margin-left: 1100px;
  }
`;

export const Hexagon = styled.img`
  @media (min-width: 768px) {
    position: absolute;
    margin-top: 430px;
    margin-left: 210px;
  }

  @media (min-width: 1440px) {
    margin-top: -210px;
    margin-left: 680px;
  }
`;

export const ElementA = styled.img`
  @media (min-width: 768px) {
    position: absolute;
    margin-top: 160px;
    margin-left: 80px;
    transform: rotate(45deg);
    animation: ${moving} 3s linear infinite;
  }

  @media (min-width: 1440px) {
    margin-top: -460px;
    margin-left: 560px;
  }
`;

export const Zigzag = styled.img`
  @media (min-width: 768px) {
    position: absolute;
    margin-top: 500px;
    margin-left: 280px;
    animation: ${rotate} 3s linear infinite;
  }

  @media (min-width: 1440px) {
    margin-top: -140px;
    margin-left: 760px;
  }
`;

export const QuestionMark = styled.img`
  @media (min-width: 768px) {
    position: absolute;
    margin-top: 60px;
    margin-left: 380px;
    animation: ${rotate} 3s linear infinite;
  }

  @media (min-width: 1440px) {
    margin-top: -520px;
    margin-left: 860px;
  }
`;

export const Zigzag2 = styled.img`
  @media (min-width: 768px) {
    position: absolute;
    margin-top: 100px;
    margin-left: 180px;
  }

  @media (min-width: 1440px) {
    margin-top: -500px;
    margin-left: 700px;
  }
`;

export const ExclamationMark = styled.img`
  @media (min-width: 768px) {
    position: absolute;
    margin-top: 430px;
    margin-left: 250px;
  }

  @media (min-width: 1440px) {
    margin-top: -200px;
    margin-left: 720px;
  }
`;
